import CartDisplay from './CartDisplay'

export default CartDisplay
